import type { CSSProperties } from 'react'

export interface MatchTier {
  label: string
  badgeClass: string
  badgeStyle?: CSSProperties
}

/**
 * Shared tiering for any 0-100 match/relevance score shown to a
 * recruiter — Candidate Search v2's keyword matchScore, AI candidate
 * search's aiScore, and the Applicants page's aiMatchScore all use this
 * same scale so the badges read consistently across the app.
 */
export function getMatchTier(score: number): MatchTier {
  if (score >= 90) {
    return { label: 'Highly Matched', badgeClass: 'bg-success-transparent' }
  }
  if (score >= 75) {
    return { label: 'Strong Match', badgeClass: 'bg-success-transparent' }
  }
  if (score >= 60) {
    return { label: 'Moderately Matched', badgeClass: 'bg-warning-transparent' }
  }
  if (score >= 40) {
    return {
      label: 'Partially Matched',
      badgeClass: '',
      badgeStyle: { backgroundColor: 'rgba(253, 126, 20, 0.15)', color: '#fd7e14' },
    }
  }
  return { label: 'Low Match', badgeClass: 'bg-danger-transparent' }
}
